"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractCountryFromHeaders = exports.extractIsGDPRFromGCPHeader = exports.extractCountryFromAPIGWHeader = exports.extractIsGDPRFromAPIGWHeader = exports.CONTINENTS = exports.INVALID_CONTINENT_CODE = exports.INVALID_COUNTRY_CODE = exports.APPENGINE_COUNTRY_HEADER = exports.APIGW_GEO_HEADER_KEY = void 0;
const web_env_1 = require("@snapchat/web-env");
const web_log_1 = require("@snapchat/web-log");
// geo-header-api uses protobuf, which uses function constructor
// https://github.com/protocolbuffers/protobuf-javascript/blob/main/compatibility_tests/v3.0.0/commonjs/export_asserts.js#L11
// this is blocked under "unsafe-eval" in CSP https://csplite.com/csp148/
// and while we can use this on the server side, merely importing on client side breaks the app on page mount.
// in the interim, let's avoid shipping with the page bundle and catch any other errors by importing dynamically
// but long term, we may need to move away from this package, https://jira.sc-corp.net/browse/WEB-2415
// protobuf issue tracked in https://github.com/protocolbuffers/protobuf-javascript/issues/25
// but fixes are not being approved due to https://github.com/protocolbuffers/protobuf/pull/8955#issuecomment-1127982992
async function deserializeAPIGWHeader(apiGWGeoHeaderString, logError) {
    // bail if we're running on server as it imports function constructor usages.
    if (!(0, web_env_1.isRunningOnServer)()) {
        logError("Attempted to deserialize APIGW Header from the client-side");
        return null;
    }
    return Promise.resolve().then(() => __importStar(require("@snapchat/geo-header-api/v1/geo_header_pb"))).then((res) => res.GeoHeader)
        .then((geoHeader) => geoHeader.deserializeBinary(Buffer.from(apiGWGeoHeaderString, "base64")))
        .catch((err) => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        logError(`Failed to deserialize geo header ${err}`);
        return null;
    });
}
// https://wiki.sc-corp.net/display/MESHHELP/Geo+Header
exports.APIGW_GEO_HEADER_KEY = "x-snap-geo";
// https://wiki.sc-corp.net/display/~asiu/Deploying+a+Flask+app+to+Google+App+Engine
exports.APPENGINE_COUNTRY_HEADER = "x-appengine-country";
exports.INVALID_COUNTRY_CODE = "ZZ";
exports.INVALID_CONTINENT_CODE = exports.INVALID_COUNTRY_CODE;
exports.CONTINENTS = [
    "" /* 0 is invalid */,
    "AF",
    "AN",
    "OC",
    "AS",
    "EU",
    "NA",
    "SA", // South America
];
/**
 * The list of GDPR countries have been picked from:
 * https://reciprocity.com/resources/what-countries-are-covered-by-gdpr/
 *
 * The corresponding country codes are taken from:
 * https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
 *
 * which is mentioned as the source of country codes in CloudFront:
 * https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/using-cloudfront-headers.html
 *
 */
const GDPRCountries = new Set([
    // Austria
    "AT",
    // Belgium
    "BE",
    // Bulgaria
    "BG",
    // Croatia
    "HR",
    // Cyprus
    "CY",
    // Czech Republic
    "CZ",
    "CS",
    // Denmark
    "DK",
    // Estonia
    "EE",
    "EW",
    // Finland
    "AX",
    "FI",
    "SF",
    // France
    "FR",
    "CP",
    "FX",
    // Germany
    "DE",
    "DD",
    // Greece
    "GR",
    // Hungary
    "HU",
    // Ireland
    "IE",
    // Italy
    "IT",
    // Latvia
    "LV",
    // Lithuania
    "LT",
    // Luxembourg
    "LU",
    // Malta
    "MT",
    // The Netherlands
    "NL",
    "AN",
    // Poland
    "PL",
    // Portugal
    "PT",
    // Romania
    "RO",
    // Slovakia
    "SK",
    "CS",
    // Slovenia
    "SI",
    // Spain
    "ES",
    "EA",
    "IC",
    // Sweden
    "SE",
    // United Kingdom*
    "GB",
    "AC",
    "CQ",
    "DG",
    "TA",
    "UK",
    // for unknown country codes
    exports.INVALID_CONTINENT_CODE,
]);
/**
 * More context around Geo Header - https://wiki.sc-corp.net/display/MESHHELP/Geo+Header
 *
 * This piece of code HAS to run on Server Side and not client side,
 * since the GeoHeader library uses google-protobuf which in turn uses the javascript Function constructor method
 * (similar to eval) that is blocked by our CSP policy (unsafe-eval)
 *
 */
async function extractIsGDPRFromAPIGWHeader(apiGWGeoHeaderString, logError) {
    if (!apiGWGeoHeaderString) {
        logError("GeoHeader not found");
        // INVALID_CONTINENT_CODE
        return true;
    }
    return deserializeAPIGWHeader(apiGWGeoHeaderString, logError).then((geoHeader) => {
        // if we're unable to deserialize APIGWHeader, assume is GDPR
        if (!geoHeader)
            return true;
        const location = geoHeader.getLocation();
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (!location || !location.getCountry() || !location.getContinent()) {
            // INVALID_CONTINENT_CODE
            return true;
        }
        const continent = exports.CONTINENTS[location.getContinent()];
        return continent === "EU" || !continent;
    });
}
exports.extractIsGDPRFromAPIGWHeader = extractIsGDPRFromAPIGWHeader;
async function extractCountryFromAPIGWHeader(apiGWGeoHeaderString, logError) {
    if (!apiGWGeoHeaderString) {
        return null;
    }
    return deserializeAPIGWHeader(apiGWGeoHeaderString, logError).then((geoHeader) => {
        // if we're unable to deserialize APIGWHeader, return no country
        if (!geoHeader)
            return null;
        const location = geoHeader.getLocation();
        return location?.getCountry() ?? null;
    });
}
exports.extractCountryFromAPIGWHeader = extractCountryFromAPIGWHeader;
function extractIsGDPRFromGCPHeader(appEngineCountryCode, logError) {
    if (!appEngineCountryCode) {
        logError("GeoHeader not found");
        // INVALID_CONTINENT_CODE
        return true;
    }
    return GDPRCountries.has(appEngineCountryCode.toUpperCase());
}
exports.extractIsGDPRFromGCPHeader = extractIsGDPRFromGCPHeader;
async function extractCountryFromHeaders(headers, logError) {
    // we prioritise the cloudfront header, as a request can have both if it goes through:
    // Cloudfront CDN -> ApiGw route -> web-stories
    // and in this flow, cloudfront will have the original request's geo info
    const cloudFrontCountry = headers?.["cloudfront-viewer-country"];
    if (cloudFrontCountry && typeof cloudFrontCountry === "string") {
        return cloudFrontCountry.toUpperCase();
    }
    const apiGWHeader = headers?.[exports.APIGW_GEO_HEADER_KEY];
    const apiGHCountry = await extractCountryFromAPIGWHeader(apiGWHeader, web_log_1.log.error);
    if (apiGHCountry) {
        return apiGHCountry.toUpperCase();
    }
    logError("Failed to extract country from headers");
    return "";
}
exports.extractCountryFromHeaders = extractCountryFromHeaders;
//# sourceMappingURL=geo-utils.js.map